import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  return <section className="bg-cream-50 px-5 py-12 sm:py-20" data-id="element-56" data-mp="1gd7ioekfll8n">
      <div className="mx-auto max-w-3xl" data-id="element-57" data-mp="1gal0zm3ttpcp">
        <SectionHeading eyebrow="Dudas comunes" title="Preguntas frecuentes" data-id="element-58" data-mp="2e0zgnarbcqha" />

        <ul className="mt-6 divide-y divide-forest-900/10 border-y border-forest-900/10 sm:mt-12" data-id="element-59" data-mp="291d1gvrxd05u">
          {faqs.map((faq, index) => {
          const isOpen = index === openIndex;
          return <li key={faq.question} data-id="element-60" data-mp="1z3fe0ahw37ea" data-mpi={index}>
                <h3 data-id="element-61" data-mp="1z2dvxm2ghkn2">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 py-3.5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-forest-700 sm:gap-5 sm:py-5" data-id="element-62" data-mp="1z59sb5yno19e">
                    <span className="text-[0.85rem] font-medium leading-snug text-forest-900 sm:text-base" data-id="element-63" data-mp="fiytu4rn8c8h">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-forest-700 transition-transform duration-200 ease-out sm:h-5 sm:w-5 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-64" data-mp="6r6k5wag174y" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-65" data-mp="1smvho4gth8w">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-66" data-mp="3jz9q7q1z9gnr">
                      <p className="pb-4 pr-6 text-[0.8rem] leading-relaxed text-forest-900/70 sm:pb-6 sm:pr-10 sm:text-[0.95rem]" data-id="element-67" data-mp="1krkrg7mbccy8">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}